import { combineReducers } from 'redux'
import user from './user.reducer'
import login from './login.reducer'
import suspendStatus from './suspendStatus.reducer'
import createNotification from './createNotification.reducer'
import featureHighlights from './featureHighlights.reducer'
import register from './register.reducer'

const authReducers = combineReducers({
  user,
  login,
  register,
  suspendStatus,
  featureHighlights,
  createNotification,
})

export default authReducers
